
  // Export
  module.exports =
  {

    // Edit scripts
    edit:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Get the password script
        $.getScript(APPLICATION._PATH_PREFIX + 'includes/js/password.js?v=' + APPLICATION._PASSWORD_VERSION, function ()
        {

          // On generating the password
          $('#generate_password').not('.js-ignore').click(function ()
          {

            // Generate the password
            PasswordGenerator.generate(function (password)
            {
          
              // Show the generated password
              $('#generated_password').val(password)
          
              // Enter the password
              $('#password').val(password)

            }
            )

          }
          ).addClass('js-ignore')

        }
        )

        // On changing the email address
        $('#email_address').not('.js-ignore').change(function ()
        {

          // Get the email address
          $(this).val($(this).val().replace(/ /g, '').toLowerCase())

          // If not design contractor or admin
          if (-1 === ['1', '2', '6'].indexOf($('#account_role_id').val()))
          {

            // If no email address
            if ('' === $(this).val())
            {

              // Hide company dropdown
              $('#company_id_wrapper').hide()

              // Hide address
              $('#address_wrapper').hide()

            }

            // Otherwise if Persimmon or Charles Church
            else if ($(this).val().match(/(persimmonhomes|charleschurch)[.]com$/))
            {

              // Show company dropdown
              $('#company_id_wrapper').show()

              // Hide address
              $('#address_wrapper').hide()

            }

            // Otherwise
            else
            {

              // Show address
              $('#address_wrapper').show()

              // Hide company dropdown
              $('#company_id_wrapper').hide()

            }

          }

        }
        ).addClass('js-ignore')

        // On clicking the generated password
        $('#generated_password').not('.js-ignore').click(function ()
        {
          this.select()
        }
        ).addClass('js-ignore')

        this.onChangeAccountRole()
     
      },

      onChangeAccountRole: function ()
      {

        $('#account_role_id').not('.js-ignore').change(function ()
        {

          // Admin
          if ('1' === $(this).val())
          {
            $('#company_id_wrapper, #address_wrapper, #planning-company-wrapper').hide()
          }

          // Design contractor
          else if ('6' === $(this).val())
          {
            $('#company_id_wrapper, #address_wrapper').hide()
            $('#planning-company-wrapper').show()
          }

          // Persimmon user, always show the business/region dropdown
          else if ('2' === $(this).val())
          {
            $('#planning-company-wrapper, #address_wrapper').hide()
            $('#company_id_wrapper').show()
          }

          else
          {
            $('#planning-company-wrapper').hide()
            $('#email_address').trigger('change')
          }

        }
        ).addClass('js-ignore').trigger('change')

      }

    },

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#accounts'), APPLICATION._PATH_PREFIX + 'account/accounts', 'Account', 'accounts')        
      }

    },

    // Accounts scripts
    accounts:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#accounts', 'Account', 'accounts')
      }

    },

    // Re-sign in scripts
    reSignIn:
    {

      // The args
      args: [],

      // Signed in
      signedIn: function ()
      {

        // Remove the modal
        $('body').removeClass('show-modal')

        // Run the callback
        this.callback.apply(null, this.args)

      }

    }

  }
